(() => {
  const L_ = window.SVL_I18N || {};
  const V_ = (x) => (L_.vals && L_.vals[x]) || x;
  document.querySelectorAll("[data-svbx-init]").forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";

    const config = JSON.parse(root.querySelector("[data-config]").textContent);
    const t = config.strings || {};
    const form = root.querySelector("form");
    const button = root.querySelector("[data-submit]");
    const error = root.querySelector("[data-error]");
    const availability = root.querySelector("[data-availability]");
    let busy = false;
    const pickers = [];

    const closePickers = () => pickers.forEach((p) => {
      p.menu.hidden = true; p.trigger.setAttribute("aria-expanded", "false");
    });

    /* les lettres passent en menus pleine largeur, comme les pierres des bagues Elora */
    root.querySelectorAll("select").forEach((select) => {
      const kind = "svb-size-picker";
      const picker = document.createElement("div");
      picker.className = kind;
      picker.dataset.bundlePicker = "";

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = kind + "__button";
      trigger.setAttribute("aria-haspopup", "listbox");
      trigger.setAttribute("aria-expanded", "false");
      const value = document.createElement("span");
      value.className = kind + "__value";
      const caret = document.createElement("span");
      caret.className = kind + "__caret";
      caret.setAttribute("aria-hidden", "true");
      trigger.append(value, caret);

      const menu = document.createElement("div");
      menu.className = kind + "__menu";
      menu.setAttribute("role", "listbox");
      menu.hidden = true;

      const choices = [];
      [...select.options].forEach((option) => {
        const choice = document.createElement("button");
        choice.type = "button";
        choice.className = kind + "__option";
        choice.setAttribute("role", "option");
        choice.textContent = option.textContent;
        menu.append(choice);
        choices.push({ choice, option });
        choice.addEventListener("click", () => {
          if (busy) return;
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          closePickers();
          trigger.focus();
        });
      });

      const update = () => {
        const selected = select.selectedOptions[0];
        value.textContent = selected ? selected.textContent : "";
        choices.forEach(({ choice, option }) =>
          choice.setAttribute("aria-selected", String(option.value === select.value)));
      };

      trigger.addEventListener("click", () => {
        const open = menu.hidden;
        closePickers();
        menu.hidden = !open;
        trigger.setAttribute("aria-expanded", String(open));
      });
      picker.addEventListener("keydown", (event) => {
        const list = choices.map((c) => c.choice);
        if (event.key === "Escape") { event.preventDefault(); closePickers(); trigger.focus(); }
        else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
          event.preventDefault();
          menu.hidden = false; trigger.setAttribute("aria-expanded", "true");
          const i = list.indexOf(document.activeElement);
          const next = event.key === "Home" ? 0 : event.key === "End" ? list.length - 1
            : event.key === "ArrowDown" ? (i + 1) % list.length : i <= 0 ? list.length - 1 : i - 1;
          if (list[next]) list[next].focus();
        }
      });
      picker.addEventListener("focusout", (event) => {
        if (!picker.contains(event.relatedTarget)) { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); }
      });

      picker.append(trigger, menu);
      select.after(picker);
      select.hidden = true;
      select.tabIndex = -1;
      select.setAttribute("aria-hidden", "true");
      select.addEventListener("change", update);
      pickers.push({ trigger, menu, update });
      update();
    });
    document.addEventListener("click", (e) => { if (!e.target.closest("[data-bundle-picker]")) closePickers(); });

    const currentColor = () => root.querySelector("[data-color][aria-pressed=true]").dataset.color;
    const selectedVariant = () => config.variants.find((x) => x.option1 === currentColor());
    const showError = (m) => { error.textContent = m; error.hidden = false; };

    const sync = () => {
      const variant = selectedVariant();
      availability.hidden = !variant || variant.available;
      availability.textContent = t.unavailable || "This finish is out of stock.";
      button.disabled = busy;
      button.textContent = busy ? (t.busy || "Adding…") : (t.one || L_.addToCart || "Add to cart");
      pickers.forEach((p) => p.update());
    };

    root.querySelectorAll("[data-color]").forEach((b) => b.addEventListener("click", () => {
      if (busy) return;
      root.querySelectorAll("[data-color]").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      root.querySelector("[data-color-label]").textContent = "— " + V_(b.dataset.color);
      error.hidden = true;
      sync();
    }));
    root.querySelectorAll("select").forEach((s) => s.addEventListener("change", () => { error.hidden = true; sync(); }));

    const refreshDrawer = async (data) => {
      const drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") {
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        return;
      }
      const ids = drawer.getSectionsToRender().map((s) => s.id);
      if (!data.sections || ids.some((id) => !data.sections[id])) {
        const r = await fetch(`${window.location.pathname}?sections=${ids.join(",")}`);
        data = { sections: await r.json() };
      }
      drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      drawer.open();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cart = await fetch(((window.routes && window.routes.cart_url) || "/cart") + ".js").then((r) => r.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "duo-buy", cartData: cart });
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (busy) return;
      error.hidden = true;
      const variant = selectedVariant();
      if (!variant || !variant.available) { showError(t.unavailable || "This finish is out of stock."); return; }

      const items = [{
        id: variant.id,
        quantity: 1,
        properties: {
          [L_.propLeftInitial || "Left initial"]: root.querySelector("[data-left]").value,
          [L_.propRightInitial || "Right initial"]: root.querySelector("[data-right]").value
        }
      }];

      busy = true;
      sync();
      try {
        const drawer = document.querySelector("cart-drawer");
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        const response = await fetch(((window.routes && window.routes.cart_add_url) || "/cart/add") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || t.error);
        await refreshDrawer(data);
      } catch (e) {
        showError(e.message || t.error || "Couldn’t add to cart.");
      } finally {
        busy = false;
        sync();
      }
    });

    sync();
  });
})();
